/* New White — comportamento de apresentação (menu mobile, hotspots do
   comparativo, modal dos selos ABO). Carrinho e checkout usam o cart
   real da Shopify (/cart/add, {{ routes.cart_url }}) — sem estado local. */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function openOverlay(sel) {
    var el = $(sel);
    if (el) el.classList.add('nw-expanded');
  }
  function closeOverlays() {
    $$('.nw-overlay').forEach(function (o) { o.classList.remove('nw-expanded'); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('.header-menu-mobile-toggle')) { e.preventDefault(); openOverlay('.nw-overlay--mobile'); return; }
    if (t.closest('.nw-overlay .nw-close') || t.closest('.nw-overlay .nw-close-outside')) { e.preventDefault(); closeOverlays(); return; }

    var cont = t.closest('[data-close-aside]');
    if (cont && cont.closest('.nw-overlay')) { e.preventDefault(); closeOverlays(); return; }

    /* hotspots do comparativo (accordion de um item só) */
    var hs = t.closest('.home-comparativo__toggle');
    if (hs) {
      e.preventDefault();
      var isOpen = hs.classList.contains('is-open');
      $$('.home-comparativo__toggle').forEach(function (b) {
        b.classList.remove('is-open');
        b.setAttribute('aria-expanded', 'false');
        b.textContent = '+';
        var card = b.parentNode.querySelector('.home-comparativo__card');
        if (card) card.hidden = true;
      });
      if (!isOpen) {
        hs.classList.add('is-open');
        hs.setAttribute('aria-expanded', 'true');
        hs.textContent = '-';
        var c = hs.parentNode.querySelector('.home-comparativo__card');
        if (c) c.hidden = false;
      }
      return;
    }

    /* modal dos selos ABO */
    var abo = t.closest('[data-abo]');
    if (abo) {
      e.preventDefault();
      var m = $('[data-abo-modal="' + abo.getAttribute('data-abo') + '"]');
      if (m) { m.hidden = false; document.documentElement.style.overflow = 'hidden'; }
      return;
    }
    if (t.closest('.home-abo-modal__close') || t.closest('.home-abo-modal__overlay')) {
      e.preventDefault();
      $$('.home-abo-modal').forEach(function (m) { m.hidden = true; });
      document.documentElement.style.overflow = '';
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeOverlays();
    $$('.home-abo-modal').forEach(function (m) { m.hidden = true; });
    document.documentElement.style.overflow = '';
  });

  /* estado inicial dos hotspots: só o aberto no HTML fica visível */
  $$('.home-comparativo__hotspot').forEach(function (hs) {
    var card = hs.querySelector('.home-comparativo__card');
    var btn = hs.querySelector('.home-comparativo__toggle');
    if (card && btn) card.hidden = !btn.classList.contains('is-open');
  });
})();
